export default __webpack_public_path__ + "static/media/card-banner-manufacturingnfo.55f3e663.png";